import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowlessFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.813 15.313a1.15 1.15 0 0 1-1.626 0L12 10.126l-5.187 5.187a1.15 1.15 0 1 1-1.626-1.626l6-6a1.15 1.15 0 0 1 1.626 0l6 6c.45.449.45 1.177 0 1.626",
    clipRule: "evenodd"
  }));
}
var IcArrowlessFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowlessFill));

export { IcArrowlessFill as I };
